import React from "react";
import { AppBar, Toolbar, IconButton, Typography, Box } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useLocation } from "react-router-dom";
import lightModeIcon from "../../assets/lightmodeicon.png";
import { useSidebar } from "../../context/SidebarContext";

export const MOBILE_APP_BAR_HEIGHT = 56;

/**
 * Sticky top bar shown on phones / small tablets (below the `md` breakpoint).
 * Hosts the hamburger that opens the off-canvas sidebar drawer and shows the
 * current section name so the user always knows where they are.
 */
function MobileAppBar() {
  const { isMobile, openMobile } = useSidebar();
  const location = useLocation();

  if (!isMobile) return null;

  const section = location.pathname.split("/")[1]?.replace(/-/g, " ");
  const title = section || "Dashboard";

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        background: "#ffffff",
        color: "#1a1a2e",
        // The theme rounds every Paper by default; a top bar must be square.
        borderRadius: 0,
        borderBottom: "1px solid rgba(102, 126, 234, 0.12)",
        boxShadow: "0 2px 12px rgba(102, 126, 234, 0.08)",
      }}
    >
      <Toolbar
        disableGutters
        sx={{
          minHeight: `${MOBILE_APP_BAR_HEIGHT}px !important`,
          px: 1,
          gap: 0.5,
        }}
      >
        <IconButton
          edge="start"
          onClick={openMobile}
          aria-label="Open navigation menu"
          sx={{ color: "#667eea", ml: 0.5 }}
        >
          <MenuIcon />
        </IconButton>
        <Box
          component="img"
          src={lightModeIcon}
          alt="Pagent"
          sx={{
            width: 28,
            height: 28,
            objectFit: "contain",
            mr: 1,
            flexShrink: 0,
          }}
        />
        <Typography
          component="h1"
          noWrap
          sx={{
            fontWeight: 700,
            fontSize: "17px",
            letterSpacing: "-0.01em",
            textTransform: "capitalize",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            minWidth: 0,
          }}
        >
          {title}
        </Typography>
      </Toolbar>
    </AppBar>
  );
}

export default MobileAppBar;
